/* Product cards on pointer devices: while the pointer stays on the image, the hover image steps through
   the remaining product images and the main image in a loop (data-hover-loop on the hover link, URLs
   separated by "|"). Leaving the card restores the theme's own hover image. */
(function () {
  if (!window.matchMedia("(any-hover: hover)").matches) return;

  var STEP_MS = 1500;

  function setup(link) {
    if (link.dataset.hoverLoopReady) return;
    link.dataset.hoverLoopReady = "1";

    var urls = (link.dataset.hoverLoop || "").split("|").filter(Boolean);
    var img = link.querySelector("img");
    if (!img || !urls.length) return;

    var original = { src: img.getAttribute("src"), srcset: img.getAttribute("srcset") };
    // The theme's own hover image closes the loop, so a product with two images still alternates.
    urls.push(original.src);
    var wrapper = link.closest(".product-item__image-wrapper") || link;
    var timer = null;
    var index = -1;

    function show(url) {
      img.removeAttribute("srcset");
      img.setAttribute("src", url);
    }

    function step() {
      index = (index + 1) % urls.length;
      show(urls[index]);
    }

    wrapper.addEventListener("mouseenter", function () {
      urls.forEach(function (url) {
        new Image().src = url;
      });
      clearInterval(timer);
      index = -1;
      timer = setInterval(step, STEP_MS);
    });

    wrapper.addEventListener("mouseleave", function () {
      clearInterval(timer);
      timer = null;
      index = -1;
      if (original.srcset) img.setAttribute("srcset", original.srcset);
      img.setAttribute("src", original.src);
    });
  }

  function scan(root) {
    (root || document).querySelectorAll("[data-hover-loop]").forEach(setup);
  }

  // Short glitch whenever the pointer enters a card image that has a second image.
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  document.addEventListener("mouseover", function (event) {
    if (reduce) return;
    var wrapper = event.target.closest && event.target.closest(".product-item__image-wrapper");
    if (!wrapper || (event.relatedTarget && wrapper.contains(event.relatedTarget))) return;
    // Only cards that switch to a second image glitch (Michel, 19.10.2026); single-image cards stay calm.
    if (!wrapper.classList.contains("product-item__image-wrapper--has-hover")) return;
    // A new set of bars for every hover: random angle (both directions), height, thickness.
    var slope = (6 + Math.random() * 14) * (Math.random() < 0.5 ? -1 : 1);
    function bar() {
      var y = 4 + Math.random() * 82;
      var t = 1.2 + Math.random() * 2.4;
      var y2 = y - slope;
      return "polygon(0 " + y.toFixed(1) + "%, 100% " + y2.toFixed(1) + "%, 100% " + (y2 + t).toFixed(1) + "%, 0 " + (y + t).toFixed(1) + "%)";
    }
    ["ga0", "ga1", "ga2", "ga3", "gb0", "gb1", "gb2"].forEach(function (key) {
      wrapper.style.setProperty("--lm-" + key, bar());
    });
    wrapper.classList.remove("is-glitching");
    void wrapper.offsetWidth;
    wrapper.classList.add("is-glitching");
    clearTimeout(wrapper._glitchTimer);
    wrapper._glitchTimer = setTimeout(function () {
      wrapper.classList.remove("is-glitching");
    }, 260);
  });

  scan();
  new MutationObserver(function (records) {
    records.forEach(function (record) {
      record.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) scan(node);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
